/**
 * All API access is provided through these functions.
 */

const axios = require('axios').default

const API_BASE = process.env.VUE_APP_API_BACKEND

let postLogin = async (payload) => {
  /**
   * Payload tbd (user + pass).
   */
  let formData = new FormData()
  formData.append('username', payload.username)
  formData.append('password', payload.password)
  formData.append('grant_type', payload.grant_type)
  const resp = await axios.post(API_BASE + '/token', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return resp.data // {token: <token>}
}

let getUsers = async (token) => {
  const resp = await axios.get(API_BASE + '/users', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data // {???}
}

let postCreateUser = async (token, payload) => {
  /**
   * Payload = {email, password, role}
   */
  const resp = await axios.post(API_BASE + '/users', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

let deleteUser = async (token, username) => {
  const resp = await axios.delete(API_BASE + `/users/${username}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

let putChangePassword = async (token, payload, username) => {
  /**
   * payload = {password (current), newPassword}
   */
  const resp = await axios.put(API_BASE + `/users/${username}/password`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

let putModifyUser = async (token, payload, userEmail) => {
  /**
   * payload = {password (optional), role (opional)}
   */
  const resp = await axios.put(API_BASE + `/users/${userEmail}`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

let getProfile = async (token) => {
  const resp = await axios.get(API_BASE + '/profile', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data // {???}
}

const postValidateExcel = async (token, category, sheetName, formData, requestConfig) => {
  let sheet = sheetName ? sheetName : null
  const resp = await axios.post(API_BASE + `/validate/${category}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    params: {
      // query params
      sheet: sheet,
    },
    ...requestConfig,
  })
  return resp
}

const postSubmitExcel = async (token, category, sheetName, formData, requestConfig) => {
  let sheet = sheetName ? sheetName : null
  const resp = await axios.post(API_BASE + `/process/${category}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    params: {
      // query params
      sheet: sheet,
    },
    ...requestConfig,
  })
  return resp
}

const getJobStatus = async (token, jobId) => {
  const resp = await axios.get(API_BASE + `/job_status/${jobId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp
}

const getApiVersion = async (token) => {
  try {
    const resp = await axios.get(API_BASE + '/api_version', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return resp.data
  } catch (err) {
    return '0.0.1'
  }
}

const getCategories = async (token) => {
  try {
    const resp = await axios.get(API_BASE + '/list_categories', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return resp.data.project_list
  } catch (err) {
    // TODO: Hard-coded list!
    return [
      { text: 'Mathematics', value: 'mathematics' },
      { text: 'MoCos', value: 'material' },
      { text: 'VTO RTR', value: 'vto' },
      { text: 'Custom', value: 'ocp' },
      { text: 'SGH', value: 'sgh' },
    ]
  }
}

const getIngestFields = async (token, fieldType) => {
  const resp = await axios.get(API_BASE + `/ingest-fields/${fieldType}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

const postCreateFieldMapping = async (token, payload) => {
  console.log(payload)
  const resp = await axios.post(API_BASE + '/ingest-fields/', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return resp.data
}

const deleteFieldMapping = async (token, payload) => {
  console.log(payload)
  let entity = payload.entity
  let sourceName = payload.sourceName
  const resp = await axios.delete(
    API_BASE + `/ingest-fields/${entity}/${sourceName}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  return resp.data
}

export default {
  postLogin,
  getUsers,
  postCreateUser,
  deleteUser,
  putChangePassword,
  putModifyUser,
  getProfile,
  postValidateExcel,
  postSubmitExcel,
  getApiVersion,
  getCategories,
  getIngestFields,
  postCreateFieldMapping,
  deleteFieldMapping,
  getJobStatus,
}
